const Loading = ({ bg = "", height, message = "Loading..." }) => {
  return (
    <div
      className={`flex justify-center items-center px-4 py-6 ${bg || "bg-white"} ${height || "min-h-[200px]"}`}
    >
      <div className="flex flex-col justify-center items-center gap-3">
        <div
          className="animate-spin rounded-full h-10 w-10 border-2 border-gray-200 border-t-theme"
          aria-hidden
        />
        <span className="text-sm font-medium text-gray-600">{message}</span>
      </div>
    </div>
  );
};

export default Loading;